import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const sampleFileDownload = (fileName: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.sampleFileDownload),
    method: 'POST',
    responseType: 'arraybuffer',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      fileName,
      configParams: {
        mediaType: 'XLSX',
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { sampleFileDownload }
